import { gql } from '@apollo/client';

export const HeroBannersQuery = gql`
    query HeroBanners {
        heroBanners {
            guid
            contentType
            title
            byline
            description
            genres {
                code
            }
            instruments {
                code
            }
            entity {
                ... on Pack {
                    guid
                    type
                    artworkUrl
                    backgroundColor
                    description
                    foregroundColor
                    isExclusive
                    name
                    slug
                    genres {
                        code
                    }
                    mainGenre {
                        code
                    }
                    label {
                        guid
                        name
                        slug
                    }
                }
                ... on Repack {
                    guid
                    type
                    artworkUrl
                    backgroundColor
                    description
                    foregroundColor
                    isExclusive
                    name
                    slug
                    instrument {
                        code
                    }
                    genres {
                        code
                    }
                    mainGenre {
                        code
                    }
                }
                ... on Label {
                    guid
                    description
                    name
                    slug
                }
            }
            labelPacks {
                guid
                artworkUrl
                backgroundColor
                foregroundColor
                isExclusive
                name
                slug
                type
            }
        }
    }
`;
